'use strict';

module.exports = {
  Facebook: 'rgba(80, 124, 190, 1)',
  Twitter: 'rgba(99, 205, 241, 1)',
  GooglePlus: 'rgba(241, 98, 97, 1)',
  Email: 'rgba(252, 201, 93, 1)',
  Pinterest: 'rgba(241, 98, 97, 1)',
  Linkedin: 'rgba(144, 202, 221, 1)'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-share/dist/styled/colors.js
// module id = 56
// module chunks = 168707334958949